import nav from '../components/nav'
import snav from '../components/searchNav'
import foot from '../components/foot'
import swiper from '../components/swiper'
import goodCard from '../components/goodCard'
import goodList from '../components/goodList'
import Calendar from '../components/mobileDate'
import order from '../components/order'
import takeperson from '../components/takeperson'
import MescrollVue from 'mescroll.js/mescroll.vue'
import area from '../components/area.vue'
import agreement from '../view/common/popRule'
import calculation from '../components/calculation'

function plugin (Vue) {
  if (plugin.installed) {
    return
  }
  Vue.component('topNav', nav)
  Vue.component('snav', snav)
  Vue.component('footBar', foot)
  Vue.component('swiperBox', swiper)
  Vue.component('goodCard', goodCard)
  Vue.component('goodList', goodList)
  Vue.component('Calendar', Calendar)
  Vue.component('order', order)
  Vue.component('takeperson', takeperson)
  Vue.component('MescrollVue', MescrollVue)
  Vue.component('cityArea', area)
  Vue.component('agreement', agreement)
  Vue.component('calculation', calculation)
}
export default plugin



// WEBPACK FOOTER //
// ./src/util/components.js